import React from "react";
import classNames from "classnames";
import Images from "constants/Images";
import { toVND } from "utils/currencyFormat";
import { FOOD_ITEM_TYPES } from "constants/types";
import Skeleton from "react-loading-skeleton";
import "./foodItem.scss";
import { icons } from "assets/icons";

const FoodItem = (props) => {
  const {
    type = FOOD_ITEM_TYPES.DETAILS /* simple or detail */,
    id,
    code,
    title,
    currentQuantityInCart = 0,
    imgSrc,
    shortDescription,
    description,
    originalPrice,
    currentPrice,
    handleOpenMenuOrder,
    handleOpenQuantityMenuPopup,
    navigateToSmartOrderMenu,

    isOutOfStock = false,
    isStoreClosed = false,
    percentDiscount,
    ...rest
  } = props;

  const handleClickItem = () => {
    if (navigateToSmartOrderMenu) {
      return navigateToSmartOrderMenu();
    }

    if (isOutOfStock || isStoreClosed) {
      return;
    }

    if (currentQuantityInCart > 0) {
      if (handleOpenQuantityMenuPopup) {
        return handleOpenQuantityMenuPopup(id)();
      }
    }

    if (handleOpenMenuOrder) {
      return handleOpenMenuOrder(id)();
    }
  };

  return (
    <div
      {...rest}
      onClick={handleClickItem}
      className="position-relative d-flex flex-column store-detail__food-item__wrapper"
    >
      {(isOutOfStock || isStoreClosed) && (
        <div
          className="position-absolute top-0 start-0 end-0 bottom-0 bgr-white"
          style={{
            opacity: 0.6,
          }}
        />
      )}

      <div className="food-image__wrapper">
        <object
          data={imgSrc || Images.foodPlaceholder}
          type="image/png"
          className="food-image"
        >
          <img src={Images.foodPlaceholder} alt="" className="food-image" />
        </object>
        {percentDiscount > 0 && (
          <>
            <img
              className={classNames(
                "sale-image",
                (isOutOfStock || isStoreClosed) && "item-disabled"
              )}
              src={icons.iconFlag}
            />
            <div
              className={classNames(
                "text-truncate _fs-13px _fw-600",
                "txt-sale",
                (isOutOfStock || isStoreClosed) && "item-disabled"
              )}
            >
              <span className="color-black">-{percentDiscount}%</span>
            </div>
          </>
        )}
      </div>

      <div>
        <div
          className={classNames(
            "text-truncate _fs-13px _fw-600",
            currentQuantityInCart > 0 && "_fw-700"
          )}
        >
          {currentQuantityInCart > 0 && (
            <span className="color-dark_orange">{currentQuantityInCart}x </span>
          )}
          <span className="color-black">{title}</span>
        </div>

        <p
          className={classNames(
            "mb-2 _fs-12px _fw-400 text-on-1-line",
            isOutOfStock && "color-danger"
          )}
        >
          {isOutOfStock
            ? "Hết món"
            : type === FOOD_ITEM_TYPES.DETAILS && description}
        </p>

        <div
          className={classNames(
            type === FOOD_ITEM_TYPES.DETAILS &&
              "d-flex flex-wrap align-items-baseline"
          )}
        >
          <div>
            <span className="_fw-600 _fs-15px color-orange mr-2">
              {toVND(currentPrice)}
            </span>
          </div>

          {Number(originalPrice) > 0 && (
            <div>
              <span className="_fw-500 _fs-13px color-silver_chalice strike-low">
                {toVND(originalPrice)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(FoodItem);

export const FoodItemSkeleton = ({ ...rest }) => {
  return (
    <div
      className="position-relative d-flex flex-column store-detail__food-item__wrapper"
      {...rest}
    >
      <div className="food-image__wrapper">
        {/* <img src={imgSrc || Images.foodPlaceholder} alt="" /> */}
        <Skeleton className="food-image food-image--skeleton" />
      </div>

      <div>
        <div className={classNames("text-truncate _fs-13px _fw-600")}>
          <span className="color-black">
            {/* {title} */}
            <Skeleton width="15ch" />
          </span>
        </div>

        <div className={classNames("d-flex flex-wrap align-items-baseline")}>
          <div>
            <span className="_fw-600 _fs-15px color-orange mr-2">
              {/* {toVND(currentPrice)} */}
              <Skeleton width="7ch" />
            </span>
          </div>

          <div>
            <span className="_fw-500 _fs-12px color-silver_chalice">
              {/* {toVND(14000)} */}
              <Skeleton width="7ch" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
